




























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { EditorProfile, EditorSettings, EditorSettingsSave, EditorProfileSave } from "@/services/editorProfiles/types";
import { getEditorProfile, updateEditorProfile, createEditorProfile } from "@/services/editorProfiles/editorProfilesService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import { bus } from "@/bus";
import { ValidationModel, ValidationType } from "@/services/validation/types";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";

@Component<EditorProfileForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        HeaderActionButtons,
        UnsavedFormModal
    },
    directives: {
        validate
    }
})
export default class EditorProfileForm extends Vue {
    @Prop() private editorProfileId!: string;

    // local state
    editorProfile = {
        id: "",
        name: "",
        settingsJson: [] as Array<EditorSettings>
    } as EditorProfile;

    editorProfileSave = {
        id: "",
        name: "",
        settingsJson: [] as Array<EditorSettingsSave>
    } as EditorProfileSave;

    // used for comparing if form have changes
    priorEditorProfileState = JSON.parse(JSON.stringify(this.editorProfile)) as EditorProfile;

    validators = {
        name: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 4 }
            ]
        } as ValidationModel
    }

    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    showNameInput = false;
    localId = this.editorProfileId || "";

    // lifecycle hooks
    created() {
        this.editorProfile.settingsJson = JSON.parse(JSON.stringify(EditorSettings));
        this.priorEditorProfileState.settingsJson = JSON.parse(JSON.stringify(EditorSettings));
        if (this.editMode) {
            this.fetchData();
        }
    }

    // computed
    get editMode() {
        return !!this.localId;
    }

    // methods
    fetchData() {
        getEditorProfile(this.localId).then(response => {
            this.editorProfile.id = response.id;
            this.editorProfile.name = response.name;
            bus.$emit("documentTitle", this.editorProfile.name);
            this.editorProfile.settingsJson.forEach(function (element, index) {
                const responseSetting: EditorSettings | undefined = response.settingsJson.find(x => x.name === element.name);
                if (responseSetting) {
                    element.name = responseSetting.name;
                    element.selectedItems = responseSetting.selectedItems;
                }
            });
            this.priorEditorProfileState = JSON.parse(JSON.stringify(this.editorProfile));
        });
    }

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            const noChanges = this.lodash.isEqual(this.priorEditorProfileState, this.editorProfile);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        if (!await validateForm([this.validators])) {
            this.showNameInput = true;
            return;
        }

        this.saveClicked = true;
        this.setEditorProfileDto();
        if (!this.editMode) {
            createEditorProfile(this.editorProfileSave).then((id: string) => {
                if (back) this.$router.push("/EditorProfiles");
                else {
                    this.localId = id;
                    this.editorProfileSave.id = id;
                    this.editorProfile.id = id;
                    this.priorEditorProfileState = JSON.parse(JSON.stringify(this.editorProfile)) as EditorProfile;
                    this.showNameInput = false;
                    this.saveClicked = false;
                }
            });
        } else {
            updateEditorProfile(this.editorProfileSave).then(() => {
                this.showNameInput = false;
                if (back) this.$router.push("/EditorProfiles");
                this.saveClicked = false;
                this.priorEditorProfileState = JSON.parse(JSON.stringify(this.editorProfile)) as EditorProfile;
            });
        }
    }

    setEditorProfileDto() {
        const that = this;
        this.editorProfileSave.id = this.editorProfile.id;
        this.editorProfileSave.name = this.editorProfile.name;
        this.editorProfileSave.settingsJson = [];
        this.editorProfile.settingsJson.forEach(function (element, index) {
            that.editorProfileSave.settingsJson.push({
                name: element.name,
                selectedItems: element.selectedItems
            });
        });
    }

    back() {
        window.history.go(-1);
    }

    async handleEnter() {
        if (await validateForm([this.validators])) this.showNameInput = false;
    }
}
